import React from "react";
import "../../styles/Css/Automation.css";

const AutomationSection = () => {
    const automationFeatures = [
        'No manual data tracking',
        'No repetitive emails',
        'No spreadsheet chaos',
        'No missed deadlines',
    ];

    return (
        <section className="automation">
            <div className="automation__container">
                <div className="automation__content">
                    <h2 className="automation__title">
                        70% of Your Transaction<br />Work — <span className="gradient-text">Automated</span>
                    </h2>
                    <ul className="automation__list">
                        {automationFeatures.map((feature, index) => (
                            <li key={index} className="automation__item">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="20 6 9 17 4 12" />
                                </svg>
                                {feature}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="automation__demo">
                    <div className="automation__comparison">
                        <div className="automation__comparison-item">
                            <span className="automation__comparison-label">Manual Process</span>
                            <span className="automation__comparison-badge automation__comparison-badge--manual" style={{ cursor: "pointer" }}>8 hrs</span>
                        </div>
                        <div className="automation__comparison-divider">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="13 17 18 12 13 7" />
                                <polyline points="6 17 11 12 6 7" />
                            </svg>
                        </div>
                        <div className="automation__comparison-item">
                            <span className="automation__comparison-label">AI Automated</span>
                            <span className="automation__comparison-badge automation__comparison-badge--ai" style={{ cursor: "pointer" }}>2.4 hrs</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default AutomationSection;